import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-confirmation-download-box',
  templateUrl: './confirmation-download-box.component.html',
  styleUrls: ['./confirmation-download-box.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ConfirmationDownloadDialogBoxComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService
  ) {}
}
